import React from "react";
import {formatRP, formatTimestamp } from "../../../../Utils/externalFunctions";
import {
  Badge,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import TabComponent from "./TabComponent";

const ModalDetailCapaianIK = ({
  rincianModalOpen,
  toggleRincianModal,
  selectedCapaian,
}) => {

  const calculateTotal = () => {
    switch (selectedCapaian.tipe_konsolidasi) {
      case "SUM":
        return (
          parseFloat(selectedCapaian.target_tw_1) +
          parseFloat(selectedCapaian.target_tw_2) +
          parseFloat(selectedCapaian.target_tw_3) +
          parseFloat(selectedCapaian.target_tw_4)
        );

      case "AVERAGE":
        return (
          (parseFloat(selectedCapaian.target_tw_1) +
            parseFloat(selectedCapaian.target_tw_2) +
            parseFloat(selectedCapaian.target_tw_3) +
            parseFloat(selectedCapaian.target_tw_4)) /
          4
        );

      case "LAST VALUE":
        return parseFloat(selectedCapaian.target_tw_4);

      default:
        return null;
    }
  };

  return (
      <Modal
        isOpen={rincianModalOpen}
        toggle={() => toggleRincianModal(selectedCapaian)}
        size="xl"
        scrollable={true}
      >
        <ModalHeader toggle={() => toggleRincianModal(selectedCapaian)}>
          Rincian Capaian
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              {selectedCapaian ? (
                <>
                  <Row>
                    <Col>
                      <Table style={{ tableLayout: "fixed", width: "100%" }}>
                        <tbody>
                          <tr>
                            <th colSpan="2">Unit Kerja</th>
                            <td colSpan="2">: {selectedCapaian?.unit_kerja}</td>
                            <th colSpan="2">Perspektif</th>
                            <td colSpan="2">: {selectedCapaian?.perspektif}</td>
                          </tr>
                          <tr>
                            <th colSpan="2">Kode SS</th>
                            <td colSpan="2">: {selectedCapaian?.kode_ss}</td>
                            <th colSpan="2">Nama SS</th>
                            <td colSpan="2">: {selectedCapaian?.nama_ss}</td>
                          </tr>
                          <tr>
                            <th colSpan="2">Kode IK</th>
                            <td colSpan="2">: {selectedCapaian?.kode_ik}</td>
                            <th colSpan="2">Nama IK</th>
                            <td colSpan="2">: {selectedCapaian?.nama_ik}</td>
                          </tr>
                          <tr>
                            <th colSpan="2">Formula</th>
                            <td colSpan="2">: {selectedCapaian?.formula}</td>
                            <th colSpan="2">Polarisasi</th>
                            <td colSpan="2">: {selectedCapaian?.polarisasi}</td>
                          </tr>
                          <tr>
                            <th colSpan="2">Tipe Konsolidasi</th>
                            <td colSpan="2">: {selectedCapaian?.tipe_konsolidasi}</td>
                            <th colSpan="2">Satuan</th>
                            <td colSpan="2">: {selectedCapaian?.satuan_capaian}</td>
                          </tr>
                          <tr>
                            <th colSpan="2">Bobot IK</th>
                            <td colSpan="2">: {selectedCapaian?.bobot_ik}</td>
                            <th colSpan="2">Dokumen Pendukung</th>
                            <td colSpan="2">: {selectedCapaian?.uploaded_document}</td>
                          </tr>
                          <tr>
                            <th colSpan="2">Anggaran</th>
                            <td colSpan="2">: Rp{formatRP(selectedCapaian?.anggaran)}</td>
                            <th colSpan="2">Komitmen</th>
                            <td colSpan="2">: Rp{formatRP(selectedCapaian?.komitmen)}</td>
                          </tr>
                          <tr>
                            <th colSpan="2">Terpakai</th>
                            <td colSpan="2">: Rp{formatRP(selectedCapaian?.aktual)}</td>
                            <th colSpan="2">Sisa Anggaran</th>
                            <td colSpan="2">: Rp{formatRP(selectedCapaian?.sisa_anggaran)}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                  <div className="mt-5">
                    <h4 className="text-center">Total Target Setahun</h4>
                    <h5 className="text-center">
                      <Badge color="success">{calculateTotal()}</Badge>
                    </h5>
                  </div>
                  <TabComponent>
                    {
                      (triwulan) => (
                        <Table style={{ tableLayout: "fixed", width: "100%" }}>
                          <tbody>
                            <tr>
                              <th colSpan="2">Target</th>
                              <td colSpan="2">: {selectedCapaian[`target_tw_${triwulan}`]}</td>
                              <th colSpan="2">Total Target</th>
                              <td colSpan="2">: {selectedCapaian[`total_target_tw_${triwulan}`] || "-"}</td>
                            </tr>
                            <tr>
                              <th colSpan="2">Capaian</th>
                              <td colSpan="2">: {selectedCapaian[`capaian_tw_${triwulan}`] || "-"}</td>
                              <th colSpan="2">Total Capaian</th>
                              <td colSpan="2">: {selectedCapaian[`total_capaian_tw_${triwulan}`] || "-"}</td>
                            </tr>
                            <tr>
                              <th colSpan="2">Persentase Capaian</th>
                              <td colSpan="2">: {selectedCapaian[`persentase_capaian_tw_${triwulan}`] || "-"}</td>
                              <th colSpan="2">Persentase Capaian Normalisasi</th>
                              <td colSpan="2">: {selectedCapaian[`persentase_capaian_normalisasi_tw_${triwulan}`] || "-"}</td>
                            </tr>
                            <tr>
                              <th colSpan="2">Nilai Indikator</th>
                              <td colSpan="2">: {selectedCapaian[`nilai_indikator_tw_${triwulan}`] || "-"}</td>
                              <th colSpan="2">Nilai Indikator Normalisasi</th>
                              <td colSpan="2">: {selectedCapaian[`nilai_indikator_normalisasi_tw_${triwulan}`] || "-"}</td>
                            </tr>
                            <tr>
                              <th colSpan="2">Terakhir Upload Dokumen</th>
                              <td colSpan="2">: {selectedCapaian[`last_uploaded_document_tw_${triwulan}`] ? formatTimestamp(selectedCapaian[`last_uploaded_document_tw_${triwulan}`]) : "-"}</td>
                              <th colSpan="2">Status</th>
                              <td colSpan="2">: {selectedCapaian[`status_tw_${triwulan}`] || "-"}</td>
                            </tr>
                            <tr>
                              <th colSpan="2">Keterangan</th>
                              <td colSpan="2">: {selectedCapaian[`keterangan_tw_${triwulan}`] || "-"}</td>
                            </tr>
                          </tbody>
                      </Table>
                      )
                    }
                  </TabComponent>
                </>
              ) : (
                <p>Loading</p>
              )}
            </Col>
          </Row>
        </ModalBody>
      </Modal>
  );
};
export default ModalDetailCapaianIK;

